import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <div className="bg-[#D4A89A]/10 py-20" data-id="element-1">
      <Section data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] mb-12 text-center" data-id="element-3">
          Para quién es (y para quién no)
        </h2>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-4">
          {/* For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#B8845C]" data-id="element-5">
            <h3 className="text-2xl font-bold text-[#3D2B1F] mb-6 flex items-center gap-2" data-id="element-6">
              <CheckCircle2 className="text-[#B8845C]" data-id="element-7" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {['Eres mujer 65+ y vives en USA', 'Estás en duelo o en soledad profunda', 'Te pega fuerte en la tarde/noche', 'No quieres un libro largo: quieres qué hacer hoy'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-[#3D2B1F]/80" data-id="element-9">
                  <span className="text-[#B8845C] mt-1.5" data-id="element-10">•</span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-gray-400" data-id="element-11">
            <h3 className="text-2xl font-bold text-[#3D2B1F] mb-6 flex items-center gap-2" data-id="element-12">
              <XCircle className="text-gray-400" data-id="element-13" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-14">
              {['Buscas terapia clínica dentro de un PDF', 'Estás en crisis aguda o en riesgo (ayuda inmediata: 988)', 'Quieres “olvidar rápido” sin sentir nada'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-[#3D2B1F]/80" data-id="element-15">
                  <span className="text-gray-400 mt-1.5" data-id="element-16">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-17">
          <h3 className="text-2xl font-serif font-bold text-[#3D2B1F] mb-6" data-id="element-18">
            Lo que puedes esperar después de 21 días
          </h3>
          <p className="text-lg text-[#3D2B1F]/80 mb-8" data-id="element-19">
            Sin prometer “curarte”, sí puedes esperar algo muy real:
          </p>
          <div className="grid gap-4 text-left md:text-center" data-id="element-20">
            {['Menos tardes a la deriva', 'Más control sobre tus horas difíciles', 'Un hogar que se siente menos como eco y más como refugio', 'Una rutina mínima que te sostiene incluso cuando no tienes ganas', 'Primeros “puentes” de contacto humano sin vergüenza'].map((item, i) => <div key={i} className="bg-white/50 px-4 py-3 rounded-lg border border-[#B8845C]/10 text-[#3D2B1F]" data-id="element-21">
                {item}
              </div>)}
          </div>
          <p className="mt-8 text-xl font-serif italic text-[#B8845C]" data-id="element-22">
            A veces, eso es el inicio de todo.
          </p>
        </div>
      </Section>
    </div>;
}